module.exports = __webpack_public_path__ + "img/header-memoireRingsBudgetLow.2926fe0.webp";